/**
 * Empty container component
 */
import withOpacity from '@shared/components/utils/hoc/withOpacity';
import styled from 'styled-components';

/**
 * Styled container for the empty container.
 */
const EmptyContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 2;
`;

export default withOpacity(EmptyContainer);
